import packageJson from '../../package.json'

const { version } = packageJson

const uri: { [key: string]: string } = {
  development: 'https://homolog.agentic-ai.arista.com.br',
  production: 'to-do',
  test: 'http://localhost:8000'
}

const APP_ENV = process.env.APP_ENV || 'development'
const COOKIES = {
  ACCESS_TOKEN: 'access_token',
  USER_DATA: 'user_data'
}

export { uri, version, COOKIES, APP_ENV }